// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
import { scalarMult } from "@stablelib/x25519";
import { hsalsa } from "@stablelib/xsalsa20";
import { secretBox, openSecretBox } from "./secretbox.js";
import { wipe } from "@stablelib/wipe";
export { generateKeyPair } from "@stablelib/x25519";
const zeros16 = new Uint8Array(16);
export function precomputeSharedKey(theirPublicKey, mySecretKey) {
    // Compute scalar multiplication result.
    const key = scalarMult(mySecretKey, theirPublicKey);
    // Hash key with HSalsa function.
    hsalsa(key, zeros16, key);
    return key;
}
export function box(theirPublicKey, mySecretKey, nonce, data) {
    const sharedKey = precomputeSharedKey(theirPublicKey, mySecretKey);
    const result = secretBox(sharedKey, nonce, data);
    wipe(sharedKey);
    return result;
}
export function openBox(theirPublicKey, mySecretKey, nonce, data) {
    const sharedKey = precomputeSharedKey(theirPublicKey, mySecretKey);
    const result = openSecretBox(sharedKey, nonce, data);
    wipe(sharedKey);
    return result;
}
//# sourceMappingURL=box.js.map